import RecommendationsBlock from './RecommendationsBlock.vue'

export default RecommendationsBlock
